import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ReferenceBlock } from '../../components/reference-block';

export interface SlackReferenceNodeAttributes {
  url: string;
  avatar: string;
  username: string;
  content: string;
  date: string;
}

export const SlackReferenceNode = Node.create({
  name: 'slackReferenceNode',
  type: 'slackReferenceNode',
  group: 'block',
  atom: true,
  inline: false,
  selectable: false,
  draggable: true,

  parseHTML() {
    return [{ tag: 'slack-reference-node' }];
  },
  renderText({ node }) {
    return node.attrs.url;
  },
  renderHTML({ HTMLAttributes }) {
    return ['slack-reference-node', mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return ReactNodeViewRenderer((props) => <ReferenceBlock {...props} source="slack" />);
  },
  addAttributes() {
    return {
      url: {
        default: undefined,
      },
      avatar: {
        default: undefined,
      },
      username: {
        default: undefined,
      },
      content: {
        default: undefined,
      },
      date: {
        default: undefined,
      },
    };
  },
});
